const holder = {
  closePersonsSelector(e) {
    if (holder.containerRef && !holder.containerRef.current?.contains(e.target)) {
      holder.internalStateSetter('isOpen', false);
      document.removeEventListener("mousedown", holder.closePersonsSelector)
    }
  }
};

export default {
  'MultiPersonSelector.Selector': ({ isOpen, containerRef, isReadonly }, _, internalStateSetter) => {
    if (isReadonly) return;
    holder.internalStateSetter = internalStateSetter
    holder.containerRef = containerRef
    internalStateSetter('isOpen', !isOpen);
    if (isOpen) {
      document.removeEventListener("mousedown", holder.closePersonsSelector);
    } else {
      document.addEventListener("mousedown", holder.closePersonsSelector);
    }
  },
  'MultiPersonSelector.Body.Search': ({ value }, _, internalStateSetter) => {
    const matched = value.match(/[A-Za-z0-9\s]+/g)
    if (matched?.length > 0) {
      internalStateSetter('searchTerm', matched.shift())
    }
    else {
      internalStateSetter('searchTerm', '')
    }
  },
  'MultiPersonSelector.Body.ClearAllHeader': ({ selectedPersonsIds, persons }, outlet) => {
    if (selectedPersonsIds.length > 0) {
      outlet({ selectedPersonsIds: [] });
    } else {
      outlet({ selectedPersonsIds: persons.map(p => p.person_id) })
    }
  },
  'MultiPersonSelector.Body.Properties.GroupWrapper.Person': ({ person, isSelected, selectedPersonsIds, isSingleSelect }, outlet) => {
    if (isSelected) {
      if (isSingleSelect) {
        outlet({ selectedPersonsIds: [] })
        return;
      }
      const newSelectedPersonsIds = [...selectedPersonsIds];
      const index = selectedPersonsIds.indexOf(person.person_id);
      newSelectedPersonsIds.splice(index, 1);
      outlet({ selectedPersonsIds: newSelectedPersonsIds })
    } else {
      if (isSingleSelect) {
        outlet({ selectedPersonsIds: [person.person_id] })
        return;
      }
      outlet({ selectedPersonsIds: [...selectedPersonsIds, person.person_id] })
    }
  },
  'MultiPersonSelector.Selector.LeftSide.ButtonList.PersonButton': ({ selectedPersonsIds, selectedPersonsId }, outlet) => {
    const newSelectedPersonsIds = [...selectedPersonsIds];
    const index = selectedPersonsIds.indexOf(selectedPersonsId);
    newSelectedPersonsIds.splice(index, 1);
    outlet({ selectedPersonsIds: newSelectedPersonsIds })
  }
};
